/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'clock': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<g _fill="none" fill-rule="evenodd"><circle pid="0" _fill="#8A99B2" cx="8" cy="8" r="8"/><g _stroke="#1C2330" stroke-linecap="round"><path pid="1" d="M7.257 3.625V9.04M7.262 9.128h4.782"/></g></g>'
  }
})
